export default {
  data() {
    return {
      inputType: 'number-input',
      inputTypeDef: {}
    }
  },
  methods: {

  }
}
